import type { VisibleLoadingClock, VisibleLoadingClockOptions } from './types';

/**
 * A tick counts at most this many intervals: a longer gap means the timers
 * were held back (a tab in the background, a sleeping computer), and the user
 * was not looking at the loading meanwhile.
 */
const MAX_COUNTED_TICKS = 2;

/**
 * Measures how long a loading state is seen, not how long it lasts: the time
 * the page is hidden, and gaps after held back timers, are not counted.
 */
export function createVisibleLoadingClock({
  now,
  isVisible,
  tickMs,
}: VisibleLoadingClockOptions): VisibleLoadingClock {
  const maxCountedGapMs = tickMs * MAX_COUNTED_TICKS;
  let lastTickAt = now();
  let visibleMs = 0;

  return {
    tick: () => {
      const tickAt = now();
      if (isVisible()) {
        visibleMs += Math.min(Math.max(tickAt - lastTickAt, 0), maxCountedGapMs);
      }
      lastTickAt = tickAt;
      return visibleMs;
    },
  };
}
